import React, { cloneElement } from "react";
import type { WidgetProps } from "@rjsf/utils";
import { spacing } from "../../../../../../../../stitches.config";
import {
  FieldPathProvider,
  useFieldPath,
} from "../../../FieldPathContext/FieldPathContext";
import {
  isFieldSelected,
  useSubmissionsBuilderContext,
} from "../../../SubmissionsBuilderContext";
import { withStopPropagation } from "../../../utils";
import { BuilderFieldWrapper } from "../__styles__/FieldPreviews";
import { useFieldHasError } from "../field-error-state";
import { FieldPreviewFooter } from "../FieldPreviewFooter/FieldPreviewFooter";

type BaseWidgetPreviewProps = WidgetProps & { children: React.JSX.Element };

function WrappedBaseWidgetPreview({ children }: BaseWidgetPreviewProps) {
  const { selectField, selectedField } = useSubmissionsBuilderContext();
  const { pathArray } = useFieldPath();

  const isSelected = isFieldSelected(pathArray, selectedField);
  const hasError = useFieldHasError(pathArray);

  return (
    <BuilderFieldWrapper
      onClick={withStopPropagation(() => {
        selectField(pathArray);
      })}
      isSelected={isSelected}
      hasError={hasError}
    >
      <div style={{ marginBottom: spacing.xs.toString() }}>
        {cloneElement(children, { isSubmissionBuilder: true })}
      </div>
      <FieldPreviewFooter fieldPath={pathArray} />
    </BuilderFieldWrapper>
  );
}

export function BaseWidgetPreview(props: BaseWidgetPreviewProps) {
  return (
    <FieldPathProvider path={props.name}>
      <WrappedBaseWidgetPreview {...props} />
    </FieldPathProvider>
  );
}
